import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";
import {CoinModelSendSignal} from "../../../_models/send-signal";
import * as moment from 'moment-timezone';
import {SendSignalService} from "../../../_services/send-signal.service";
import {AppConfigs} from "../../../app.config";
import {AlertBoxComponent} from "../../../_common/alert-box/alert-box.component";

declare var document: any;
declare var $: any;

@Component({
    selector: 'app-popup-setting-send-signal',
    templateUrl: './popup-setting-send-signal.component.html',
    styleUrls: ['../send-signal-event.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class PopupSettingSendSignalComponent extends DialogComponent<CoinModelSendSignal, boolean> implements AfterViewInit, OnInit {
    loading = false;
    isFromValidate: boolean = false;
    constantSendSignal: any;
    model: any = {};
    data: any;
    titlePopup: string;
    btnSaveOrUpdate: string = '';
    listCoinSendSignal: any = {};
    sendSignalEventID: number;
    lineBotID: number;

    hourList: any[] = [];
    maxLengthContent: any = 500;
    lengthContent: any = 0;
    contentDefault: string = '';
    maxFileSize: number; // 1MB
    pathImagePost: string = '';
    currencyType: any;
    currency: any;

    minutesRank: any[];
    hoursRank: any[];
    daysRank: any[];
    distanceTime: number;
    distanceTimeHours: number;
    distanceTimeDays: number;
    objRunStart: any = {};
    objCronType: any = {};
    runCronDefault: any;
    runCronTypeTime: number;
    minSendTimeYMD: any;
    blockActive: number;
    // 0: Create
    // 1: Exist
    imagePostUpdateType: number = 0;
    // Data Request
    runCronType: any;
    eventName: string;

    sendTimeYMD: any;
    sendTimeHour: any;
    sendTimeMinute: any;

    listLineCoinBot: any;
    listCoinEvent: any = [];
    // Error
    strErrorEventName: string = '';
    strErrorImagePost: string = '';
    strErrorContent: string = '';
    strErrorSendTime: string = '';

    constructor(dialogService: DialogService, private sendSignalService: SendSignalService) {
        super(dialogService);
    }

    ngOnInit() {
        let self = this;
        // Set default
        this.hourList = new Array(24).fill('').map((x, i) => {
            return i;
        });
        this.objRunStart = this.constantSendSignal.setTimeType;
        this.objCronType = this.constantSendSignal.cronType;
        this.blockActive = this.constantSendSignal.statusEvent.stopped;
        this.maxLengthContent = this.constantSendSignal.maxLengthContent;
        this.maxFileSize = this.constantSendSignal.image.maxFileSize;
        this.minutesRank = this.constantSendSignal.minutesRank;
        this.hoursRank = this.constantSendSignal.hoursRank;
        this.daysRank = this.constantSendSignal.daysRank;
        this.currencyType = Object.keys(this.constantSendSignal.currencyType).map((key) => {
            return {value: key, name: self.constantSendSignal.currencyType[key]};
        });
        // Default currency USD
        this.currency = this.currencyType.indexOf('usd') !== -1 ? this.currencyType[this.currencyType.indexOf('usd')] : 'usd';
        this.lengthContent = this.constantSendSignal.contentDefault.length;

        this.runCronType = this.objCronType.sendDays;
        this.runCronDefault = this.objRunStart.setTimeNow;
        this.listLineCoinBot = this.listCoinSendSignal.listLineBotCoinActive;
        this.listCoinEvent = this.listCoinSendSignal.listCoinEventActive;

        // Check data render dom
        // Event Name
        this.eventName = this.data ? this.data.event_name : '';
        // Send time
        this.blockActive = this.data ? +this.data.is_active : this.blockActive;
        let renderSendTimeNow = this.renderSendTimeNow();
        this.minSendTimeYMD = moment().tz(AppConfigs.TIME_ZONE).format('YYYY-MM-DD');
        this.sendTimeYMD = this.data ? moment(this.data.send_time).format('YYYY-MM-DD') : renderSendTimeNow.timeYMD;
        this.sendTimeHour = this.data ? moment(this.data.send_time).format('HH') : renderSendTimeNow.timeHour;
        this.sendTimeMinute = this.data ? moment(this.data.send_time).format('mm') : renderSendTimeNow.timeMinute;
        // Check data or create DOM radio check send Time
        this.runCronDefault = this.data ? (this.data.type_cron >= 2) ? this.objRunStart.setTime : this.runCronDefault : this.runCronDefault;
        this.runCronTypeTime = this.data ? (this.data.type_cron >= 2) ? +this.data.type_cron : this.runCronType : this.runCronType;
        // Distance Time
        this.distanceTimeHours = this.checkDistanceTime(this.objCronType.sendHours) ? this.data.distance_time : this.hoursRank[1];
        this.distanceTimeDays = this.checkDistanceTime(this.objCronType.sendDays) ? this.data.distance_time : this.daysRank[0];
        // Content
        this.currency = (this.data && this.data.hasOwnProperty('currency') && this.data.currency) ? this.data.currency.toLowerCase() : this.currency;
        this.contentDefault = this.data ? this.data.content : this.constantSendSignal.contentDefault;
        // Post image
        this.pathImagePost = (this.data && this.data.hasOwnProperty('path_images') && this.data.path_images ? (this.getDomainServe() + this.data.path_images) : this.pathImagePost);
        this.imagePostUpdateType = this.data ? 1 : this.imagePostUpdateType;
    }

    ngAfterViewInit() {
        let self = this;
        setTimeout(() => {
            self.disabledBox(this.runCronDefault);
            self.checkBoxAll();
            self.checkImagePost();
        });
    }

    renderDomCheckRadio(value) {
        this.runCronType = this.runCronTypeTime;
        this.checkSendTime();
        this.disabledBox(value);
    }

    eventCheckSendTime(event: any) {
        this.checkSendTime();
        this.disabledBox(this.objRunStart.setTime);
    }

    checkSendTime() {
        // Check send time: sendOneOnly
        this.strErrorSendTime = this.checkTypeSetTime()
            ? this.renderOrCheckSendTime(true)
                ? ''
                : '時間を現行時間より大きく設定してください。'
            : '';
    }

    checkTypeSetTime() {
        return (this.objRunStart.setTime == this.runCronDefault && this.runCronTypeTime == this.objCronType.sendOneOnly);
    }

    checkSendNow(value) {
        this.runCronType = this.objCronType.sendNow;
        this.checkSendTime();
        this.disabledBox(value);
    }

    changeValActiveEvent(event: any) {
        this.blockActive = event.target.value != this.constantSendSignal.statusEvent.stopped
            ? this.constantSendSignal.statusEvent.stopped
            : this.constantSendSignal.statusEvent.active;
    }

    disabledBox(valueID) {
        let self = this;
        $.map(self.objRunStart, function (index, element) {
            let valRunStart = self.objRunStart[element];
            $('#set-time-cron-' + valRunStart).find("*").attr("disabled", (valRunStart == valueID ? false : true));
            if (valRunStart != valueID) {
                $('#set-time-cron-' + valRunStart).find('.checkmark').addClass('disabled-box');
            } else {
                $('#set-time-cron-' + valRunStart).find('.checkmark').removeClass('disabled-box');
            }
        });
        self.customValidate();
    }

    changeDistanceTime(event: any) {
        this.distanceTime = event.target.options[event.target.selectedIndex].value;
    }

    checkDistanceTime(isTypeCron: any) {
        return (this.data && this.data.hasOwnProperty('distance_time') && this.data.hasOwnProperty('type_cron') && this.data.type_cron == isTypeCron);
    }

    renderSendTimeNow() {
        let timeNowRank = moment().tz(AppConfigs.TIME_ZONE).format('HH:mm').split(':');
        let timeNowRankHour = +timeNowRank[0];
        let timeNowRankMinute = +timeNowRank[1];
        let minutesRankHas = +this.minutesRank[1];
        let objCheckRankHour = this.checkIncrementsDay(timeNowRankHour);

        if (timeNowRankMinute < (minutesRankHas / 2)) {
            timeNowRankMinute = minutesRankHas;
        } else if (timeNowRankMinute <= minutesRankHas) {
            timeNowRankHour = objCheckRankHour.timeNowHour;
            timeNowRankMinute = +this.minutesRank[0];
        } else if (timeNowRankMinute < ((minutesRankHas / 2) + minutesRankHas)) {
            timeNowRankHour = objCheckRankHour.timeNowHour;
            timeNowRankMinute = +this.minutesRank[0];
        } else {
            timeNowRankHour = objCheckRankHour.timeNowHour;
            timeNowRankMinute = +this.minutesRank[1];
        }

        let timeYMD = objCheckRankHour.isIncrementsDay
            ? moment().tz(AppConfigs.TIME_ZONE).add(1, 'days').format('YYYY-MM-DD')
            : moment().tz(AppConfigs.TIME_ZONE).format('YYYY-MM-DD');

        return {'timeHour': timeNowRankHour, 'timeMinute': timeNowRankMinute, 'timeYMD': timeYMD};
    }

    checkIncrementsDay(timeNowHour) {
        let isIncrementsDay = (timeNowHour + 1) > 23 ? true : false;
        timeNowHour = isIncrementsDay ? 0 : (timeNowHour + 1);

        return {'isIncrementsDay': isIncrementsDay, 'timeNowHour': timeNowHour}
    }

    keyUpCharacterEventName(event: any) {
        this.strErrorEventName = (event.target.value || '').length ? '' : 'イベント名が空白にならない。';
        this.customValidate();
    }

    keyUpCharacterContent(event: any) {
        this.lengthContent = (event.target.value || '').length;
        this.strErrorContent = this.lengthContent ? '' : '内容が空白にならない。';
        this.customValidate();
    }

    fileSelected(event) {
        let self = this;
        let oImage = document.getElementById('preview');
        self.imagePostUpdateType = 0;
        self.removeImagePost('', true);
        // get selected file element
        let objFile = document.getElementById('image-files').files;
        let objFileFirst = objFile[0];
        if (objFile.length < 1) {
            oImage.removeAttribute('src');
            self.removeImagePost('画像ファイルを選択してください。');
            return;
        }

        // filter for image files
        let readFilter = /^(image\/bmp|image\/gif|image\/jpeg|image\/png|image\/tiff)$/i;
        if (objFileFirst && !readFilter.test(objFileFirst.type)) {
            self.removeImagePost('選択ファイルが画像にならない。');
            return;
        }

        // little test for filesize
        if (this.maxFileSize && objFileFirst && objFileFirst.size && objFileFirst.size > this.maxFileSize) {
            self.removeImagePost('選択ファイルが' + self.bytesToSize(self.maxFileSize) + 'の制限を超える。');
            return;
        }
        // prepare HTML5 FileReader
        let oReader = new FileReader();
        oReader.onload = function (e) {
            // e.target.result contains the DataURL which we will use as a source of the image
            oImage.src = e.target['result'];
            oImage.css = {'display': 'block'};
            self.pathImagePost = e.target['result'];
        };
        // read selected file as DataURL
        oReader.readAsDataURL(objFileFirst);
    }

    clickRemoveImagePost(event: any) {
        this.removeImagePost('');
        this.imagePostUpdateType = 0;
    }

    removeImagePost(strError: any, isRemoveDom: boolean = false) {
        $('#preview').removeAttr('src');
        $('#preview').css({'display': (!isRemoveDom ? 'none' : 'block')});
        if (!isRemoveDom) {
            $('#image-files').val('');
        }
        this.pathImagePost = '';
        this.strErrorImagePost = strError;
        this.customValidate();
    }

    checkImagePost() {
        $('#preview').css({'display': (this.pathImagePost ? 'block' : 'none')});
    }

    bytesToSize(bytes) {
        let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
        if (bytes == 0) return '0 Byte';
        let i = +(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i)) + ' ' + sizes[i];
    };

    toggleSelection(event: any) {
        let value = event.target.dataset.value;
        let checkExist = this.checkedBox(+value);
        if (checkExist) {
            // Is currently selected
            this.listCoinEvent.splice(this.listCoinEvent.indexOf(+value), 1);
        } else {
            // Is newly selected
            this.listCoinEvent.push(+value);
        }

        this.checkBoxAll();
    }

    checkedBox(value) {
        return this.listCoinEvent.indexOf(+value) != -1;
    }

    checkBoxAll() {
        $('#check-all-coin').prop('checked', (this.listCoinEvent.length == this.listLineCoinBot.length ? 'checked' : ''));
    }

    checkAllList(event) {
        let self = this;
        self.listCoinEvent = [];
        this.listLineCoinBot.map((elem, index) => {
            if (event.target.checked) {
                self.listCoinEvent.push(+elem.coin_id);
                $('#check-box-' + elem.coin_id).attr('checked', 'checked');
            } else {
                $('#check-box-' + elem.coin_id).attr('checked', '');
            }
        });

        if (!event.target.checked) {
            self.listCoinEvent = [];
        }
    }

    updateOrCreateSendSignal() {
        let self = this;
        self.loading = true;
        if (self.customValidate()) {
            self.getDataModel(uploadData => {
                self.sendSignalService.postCreateOrUpdateSignalEvent(uploadData).subscribe(resData => {
                    self.loading = false;
                    self.isFromValidate = false;
                    if (resData.hasOwnProperty('result') && resData.result == false) {
                        if (resData.hasOwnProperty('type') && resData.type === '_FAIL_') {
                            if (resData.hasOwnProperty('error')) {
                                self.dialogService.addDialog(AlertBoxComponent, {message: resData.error}).subscribe((result) => {
                                    self.close();
                                });
                            }
                        }
                    } else if (resData.hasOwnProperty('result') && resData.result == true) {
                        if (resData.hasOwnProperty('type') && (resData.type === '_VALIDATE_')) {
                            self.strErrorEventName = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('eventName')) ? resData.error.eventName[0] : '';
                            self.strErrorContent = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('txtContent')) ? resData.error.txtContent[0] : '';
                        } else if (resData.hasOwnProperty('type') && (resData.type === '_SUCCESS_')) {
                            self.isFromValidate = true;
                            this.result = true;
                            self.close();
                        }
                    }
                }, error => {
                    self.isFromValidate = false;
                });
            });
        }
    }

    renderOrCheckSendTime(isCheckTimeNow: boolean = false, sendTimeNowType: number = 0) {
        let sendTimeHour = $('#send-time-hour :selected').val();
        let sendTimeMinute = $('#send-time-minute :selected').val();
        let sendTimeFull = $('#send-time-YMD').val() + ' ' + (sendTimeHour < 10 ? '0' : '') + sendTimeHour + ':' + (sendTimeMinute < 10 ? '0' : '') + sendTimeMinute;
        let sendTimeNow = moment().tz(AppConfigs.TIME_ZONE).format('YYYY-MM-DD HH:mm');

        if (isCheckTimeNow) {
            let startDate = new Date(sendTimeFull);
            let endDate = new Date(sendTimeNow);
            return this.checkTypeSetTime() ? (endDate.getTime() < startDate.getTime()) : true;
        }
        return (this.objRunStart.setTimeNow == sendTimeNowType) ? sendTimeNow : (sendTimeFull + ':00');
    }

    customValidate() {
        let self = this;
        let cusFromValidate = false;
        let eventName = $('#event-name').val().trim().length;
        let textContent = $('#text-content').val().trim().length;
        let isCheckSendTimeFull = self.renderOrCheckSendTime(true);

        cusFromValidate = (!cusFromValidate && eventName && self.strErrorEventName.length == 0) ? true : false;
        cusFromValidate = (cusFromValidate && isCheckSendTimeFull && self.strErrorSendTime.length == 0) ? true : false;
        cusFromValidate = (cusFromValidate && textContent && self.strErrorContent.length == 0) ? true : false;
        cusFromValidate = (cusFromValidate && self.strErrorImagePost.length == 0) ? true : false;

        self.isFromValidate = cusFromValidate;
        return self.isFromValidate;
    }

    getDataModel(callback: any) {
        let self = this;
        let sendTimeFull = '';
        let eventName = $('#event-name').val().trim();
        let runCronType = self.runCronType;
        let distanceTime = 0;
        let txtContent = $('#text-content').val().trim();
        let imageSrcBase64 = ($('#preview').attr('src') || '');

        switch (self.runCronDefault) {
            case self.objRunStart.setTime: {
                sendTimeFull = self.renderOrCheckSendTime(false, self.objRunStart.setTime);
                //SET_TIME == 0
                runCronType = self.runCronTypeTime;
                if (self.runCronTypeTime > 2) {
                    distanceTime = $('#distance-time-' + self.runCronTypeTime + ' :selected').val();
                }
                break;
            }
            case self.objRunStart.setTimeNow: {
                sendTimeFull = self.renderOrCheckSendTime(false, self.objRunStart.setTimeNow);
                //SET_TIME_NOW == 1
                runCronType = self.objCronType.sendNow;
                break;
            }
            default: {
            }
        }

        // Set model
        self.model.eventName = eventName;
        self.model.runCronType = runCronType;
        self.model.sendTimeFull = sendTimeFull;
        self.model.distanceTime = distanceTime;
        self.model.txtContent = txtContent;
        self.model.imageFileBase64 = imageSrcBase64;
        self.model.listCoinEvent = this.listCoinEvent.join(',');
        self.model.sendSignalEventID = this.sendSignalEventID;
        self.model.lineBotID = this.lineBotID;
        self.model.base64MimeType = this.getBase64MimeType(imageSrcBase64);
        self.model.imagePostUpdateType = this.imagePostUpdateType;
        self.model.blockActive = this.blockActive;
        self.model.currency = this.currency;

        callback(self.model);
    }

    // we could add validation here with ensuring count( $data ) > 1
    getBase64MimeType(base64String) {
        let result = '';
        if (typeof base64String !== 'string') {
            return result;
        }
        let mime = base64String.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
        if (mime && mime.length) {
            result = mime[1];
        }
        return result;
    }

    getDomainServe() {
        return AppConfigs.API_ENDPOINT.substr(0, AppConfigs.API_ENDPOINT.indexOf('/api/')) + '/';
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/popup-setting-send-signal/popup-setting-send-signal.component.ts